import { render, staticRenderFns } from "./TarefaList.vue?vue&type=template&id=196bc4c8"
import script from "./TarefaList.vue?vue&type=script&lang=js"
export * from "./TarefaList.vue?vue&type=script&lang=js"
import style0 from "./TarefaList.vue?vue&type=style&index=0&id=196bc4c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports